/**
 * Language Service
 *
 * This service manages the user's language preference in the application.
 * It provides methods to get and set the preferred language, storing it in the browser's localStorage.
 *
 * Note: When updating the language preference setting for production, ensure to handle existing users'
 * localStorage configurations, as they may have set syllabics as their language preference.
 */

const LANGUAGE_KEY = "app_language_preference";
export const languageService = {
  /**
   * Retrieves the user's preferred language from localStorage
   * @returns {string} The preferred language, defaults to "syllabics" if not set
   */
  getPreferredLanguage: () => {
    // make sure when we update the language pereference setting on we go live,because the exisiting user would have set the language as the syllabics in the localstorage and it will not deleted automatically so ,have to write the code for that which delete the localstorage config
    return localStorage.getItem(LANGUAGE_KEY) || "syllabics";
  },

  /**
   * Sets the user's preferred language in localStorage
   * @param {string} language - The language code to set as preferred
   */
  setPreferredLanguage: (language) => {
    localStorage.setItem(LANGUAGE_KEY, language);
  },
};
